export enum AgentStatusAction {
  ACTIVATE = 'ACTIVATE',
  REACTIVATE = 'REACTIVATE',
  REVOKE = 'REVOKE',
}
